import {
  iwocapayTelDisplay,
  iwocapayTelLink,
} from '../../../../src/constants.json';
import TelephoneIcon from '../../../components/svg/TelephoneIcon.svg?react';
import { useWhiteLabelTheme } from '../../store/WhiteLabelProvider';
import { PoweredByIwocaPay } from '../WhiteLabelLogo/WhiteLabelLogo';

export const HelpBox = () => {
  const { showSellerLogo, isTheme } = useWhiteLabelTheme();
  const whiteLabelled = showSellerLogo || isTheme;
  return (
    <div className="flex justify-between pl-s pr-s xs:flex-col-reverse">
      <div className="mb-l mt-xl">
        <h4 className="m-0 text-m font-med">Need some help?</h4>
        <div className="grid grid-cols-[max-content_1fr] items-center gap-s">
          <p className="m-0 text-s">
            Give {whiteLabelled ? 'iwocaPay' : 'us'} a call on
          </p>
          <a href={iwocapayTelLink} className="text-primary-10 no-underline">
            <div className="flex items-center gap-xs">
              <TelephoneIcon className="h-[15px] w-[15px]" />
              <p className="m-0 p-0 text-s font-bold">{iwocapayTelDisplay}</p>
            </div>
          </a>
        </div>

        <div className="text-xs font-reg text-structure-40">
          Mon - Fri (9am - 6pm)
        </div>
        <a
          href="https://www.iwoca.co.uk/iwocapay-buyer-pay-later"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-primary-40"
        >
          Find out more about iwocaPay
        </a>
      </div>
      {whiteLabelled && (
        <div className="flex align-middle xs:-mb-xl">
          <PoweredByIwocaPay />
        </div>
      )}
    </div>
  );
};
